/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import { AreaChart, Area, XAxis, Tooltip, CartesianGrid } from 'recharts'
import { Data } from 'state/dashboard/types'
import { trackEvent } from 'utils/googleAnalytics'

import { DashboardItemProps } from '../types'
import { ChartContainer, TooltipContainer } from './Chart.styled'

function Chart({ data, dealershipName }: DashboardItemProps) {
    const [chartData, setChartData] = useState([])
    const [interaction, setInteraction] = useState(false)

    useEffect(() => {
        setChartData(
            data.map((item: Data) => {
                const month = new Date(`${item.month}-02`)

                return {
                    count: item.count,
                    total: item.total,
                    totalLabel: item.totalLabel,
                    month: month.toLocaleDateString('en-US', {
                        year: '2-digit',
                        month: 'short',
                    }),
                    fullMonth: month.toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                    }),
                }
            }),
        )
    }, [data])

    function trackInteraction() {
        if (interaction) return

        trackEvent(
            'Loyalty Dashboard',
            'Chart Interaction',
            'dealership',
            dealershipName,
        )

        setInteraction(true)
    }

    function formatTooltip(item: any) {
        let info: any = {}

        if (item?.payload?.length) {
            info = item.payload[0].payload
        }

        return (
            <TooltipContainer>
                <h5>{info.fullMonth}</h5>
                <ul>
                    <li>
                        <b>Deals:</b> <strong>{`${info.count}`}</strong>
                    </li>
                    <li>
                        <b>Total Funded:</b> <strong>{info.totalLabel}</strong>
                    </li>
                </ul>
            </TooltipContainer>
        )
    }

    return (
        <ChartContainer>
            <div data-testid="chart-container" onMouseEnter={trackInteraction}>
                <AreaChart
                    width={500}
                    height={200}
                    data={chartData}
                    margin={{ top: 10, right: 25, left: 25, bottom: 10 }}
                >
                    <defs>
                        <linearGradient
                            id="totalColor"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                        >
                            <stop
                                offset="5%"
                                stopColor="#2366b1"
                                stopOpacity={0.5}
                            />
                            <stop
                                offset="95%"
                                stopColor="#2366b1"
                                stopOpacity={0}
                            />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="month" interval={0} />
                    <Tooltip content={(item) => formatTooltip(item)} />
                    <Area
                        type="monotone"
                        dataKey="total"
                        stroke="#2366b1"
                        fillOpacity={1}
                        fill="url(#totalColor)"
                    />
                </AreaChart>
            </div>
        </ChartContainer>
    )
}

export default Chart
